export enum Brands {
  SJF = 'SJF',
  DFHF = 'DFHF',
  FORSIA = 'FORSIA',
}
